import { Grid, Link, Typography } from '@mui/material'

import appDownloadQr from '../../../images/hsp-plus/app-download-qr.png'
import downloadAppStore from '../../../images/hsp-plus/download-app-store.svg'
import downloadGooglePlay from '../../../images/hsp-plus/download-google-play.svg'
import protectLogo from '../../../images/protect-icon-logo.svg'
import useIsMobile from '../../../utils/hooks/useIsMobile'

import useStyles from './index.styles'

const APP_STORE_URL = 'https://apps.apple.com/us/app/meshify-protect/id1450417570'
const GOOGLE_PLAY_URL = 'https://play.google.com/store/apps/details?id=com.meshifyprotect&pcampaignid=web_share'

const HSPAppDownload = () => {
  const isMobile = useIsMobile()
  const classes = useStyles

  return (
    <Grid container={true} component="section" sx={classes.screen(isMobile)}>
      <Typography component="h1" variant="h5" sx={classes.title}>
        Head over to the Meshify Protect app
      </Typography>
      <img src={protectLogo} alt="" aria-hidden="true" width={65.893} height={67.5} />
      {!isMobile && (
        <Grid container={true} sx={classes.qrSection}>
          <Typography variant="h6">Scan QR to download the mobile app</Typography>
          <img src={appDownloadQr} alt="QR code to download the Meshify Protect app" width={139} height={139} />
        </Grid>
      )}
      <Grid container={true} sx={classes.storeLinks}>
        <Link href={APP_STORE_URL} target="_blank" rel="noopener noreferrer" aria-label="Download on the App Store">
          <img src={downloadAppStore} alt="" aria-hidden="true" />
        </Link>
        <Link href={GOOGLE_PLAY_URL} target="_blank" rel="noopener noreferrer" aria-label="Get it on Google Play">
          <img src={downloadGooglePlay} alt="" aria-hidden="true" />
        </Link>
      </Grid>
    </Grid>
  )
}

export default HSPAppDownload
